import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { db, doc, setDoc } from "../config/firebase";
import "./Profile.css";

const Profile = () => {
  const { user, userProfile, setUserProfile, loading } = useAuth();
  const navigate = useNavigate();

  const [name, setName] = useState(userProfile?.name || "");
  const [phone, setPhone] = useState(userProfile?.phone || "");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [saving, setSaving] = useState(false);

  if (!loading && !user) {
    navigate("/login");
    return null;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    const trimmedName = name.trim();
    if (!trimmedName) {
      setError("Please enter your name.");
      return;
    }

    const cleanPhone = phone.replace(/[\s\-()]/g, "").replace(/^(\+?91)/, "");
    if (!/^[6-9]\d{9}$/.test(cleanPhone)) {
      setError("Please enter a valid 10-digit phone number.");
      return;
    }

    setSaving(true);
    try {
      await setDoc(
        doc(db, "users", user.uid),
        {
          name: trimmedName,
          phone: cleanPhone,
          updatedAt: new Date().toISOString()
        },
        { merge: true }
      );

      setUserProfile((prev) => ({
        ...(prev || {}),
        name: trimmedName,
        phone: cleanPhone
      }));

      setSuccess("Profile updated successfully.");
    } catch (err) {
      console.error("Error updating profile:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="profile-page">
      <div className="profile-card">
        <div className="profile-header">
          <div className="profile-avatar">
            {(userProfile?.name || user?.displayName || "U").charAt(0).toUpperCase()}
          </div>
          <h1>Your Profile</h1>
          <p>Update your name and contact details</p>
        </div>

        {error && <div className="profile-error">{error}</div>}
        {success && <div className="profile-success">{success}</div>}

        <form onSubmit={handleSubmit} className="profile-form">
          <div className="form-group">
            <label htmlFor="profile-name">Full Name *</label>
            <input
              id="profile-name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              placeholder="Your full name"
              autoComplete="name"
            />
          </div>

          <div className="form-group">
            <label htmlFor="profile-email">Email</label>
            <input
              id="profile-email"
              type="email"
              value={user?.email || ""}
              disabled
              className="profile-input-disabled"
            />
          </div>

          <div className="form-group">
            <label htmlFor="profile-phone">Phone Number *</label>
            <input
              id="profile-phone"
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              required
              placeholder="+91 98765 43210"
              autoComplete="tel"
            />
          </div>

          <button type="submit" className="profile-save-btn" disabled={saving}>
            {saving ? "Saving..." : "Save Changes"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Profile;